export enum CUSTOMER {
    CUSTOMER_PREVIEW_USERS = 'ADMIN.NAV.CUSTOMER_PREVIEW_USERS',
    CUSTOMER_SETTINGS = 'ADMIN.NAV.CUSTOMER_SETTINGS',
    DISABLED = 'GLOBAL.DISABLED',
    ENABLED = 'GLOBAL.ENABLED',
    GLOBAL_ADMINS = 'ADMIN.NAV.SUPER_ADMINS',
    GLOBAL_ADMIN_ADD = 'ADMIN_SUPER_ADMIN_ADD',
    GLOBAL_ADMIN_DELETE = 'ADMIN_SUPER_ADMIN_DELETE',
    GLOBAL_ADMIN_DELETE_DESCRIPTION = 'ADMIN_SUPER_ADMIN_DELETE_DESCRIPTION',
    GLOBAL_ADMIN_DELETE_SUCCESS = 'ADMIN_SUPER_ADMIN_DELETE_SUCCESS',
    GRACE_PERIOD_WARNING = 'CUSTOMER.GRACE_PERIOD_WARNING',
    LICENSE_CUSTOMER_SANDBOX = 'CUSTOMER.LICENSE_CUSTOMER_SANDBOX',
    LICENSE_DEVELOPMENT = 'CUSTOMER.LICENSE_DEVELOPMENT',
    LICENSE_GRACE_PERIOD_DELETION_DELAY = 'CUSTOMER.LICENSE_GRACE_PERIOD_DELETION_DELAY',
    LICENSE_PRODUCTION = 'CUSTOMER.LICENSE_PRODUCTION',
    PAYMENT_ISSUE_BANNER = 'CUSTOMER.PAYMENT_ISSUE_BANNER',
    PENDING = 'GLOBAL.PENDING',
    SEARCH_USERS = 'ADMIN_SUPER_ADMIN_SEARCH_USERS',
}
